
import { useContext } from 'react';
import styled from 'styled-components';
import { SectionWithJobPlaceCardProps } from './query';
import JobCardWithPlace from '@/components/molecules/JobCardWithPlace';
import Title_v2 from '@/components/molecules/Title/index';
import { AppCustomContext } from '@/context/index';
import { renderUnderline } from '@/utilities/functions';

const JobCardWithPlaceContainer = styled.div`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-top: 1rem;
`;

const SectionWithJobPlaceCard = ({ sectionWithJobPlaceCardData }: { sectionWithJobPlaceCardData: SectionWithJobPlaceCardProps }) => {

	const appContext = useContext(AppCustomContext);
	const jobBoardPath: { [key: string]: string } = {
		en: 'find-a-job',
		es: 'encontrar-un-empleo',
		fr: 'trouver-un-emploi',
	};

	return (
		<>
			<Title_v2
				align={sectionWithJobPlaceCardData.title.alignedAt}
				underlineColor={sectionWithJobPlaceCardData.title.underlineColor}
			>
				{renderUnderline(sectionWithJobPlaceCardData.title.titlePieces)}
			</Title_v2>
			<JobCardWithPlaceContainer>
				{sectionWithJobPlaceCardData.places.trim().split(',').map(
					(place, index) => (
						<JobCardWithPlace
							key={index}
							href={`/${appContext.currentLocale}/${jobBoardPath[appContext.currentLocale]}?position=${sectionWithJobPlaceCardData.job}&place=${place.trim()}`}
							job={sectionWithJobPlaceCardData.job}
							place={place.trim()}
						/>
					),
				)}
			</JobCardWithPlaceContainer>
		</>
	);
};

export default SectionWithJobPlaceCard;
